import styled from 'styled-components';
import * as variables from './../../assets/css/variables';

export const Section = styled.section`
  background-color: ${variables.COLOR_BLUE};
  padding: 4rem;
  margin-top: 2rem;
  color: #FFF;
  box-shadow: 0 1px 10px #999;
`;

export const Container = styled.article`
  margin: 0 auto;
  max-width: ${variables.MAX_WIDTH};
  display: flex;
  align-items: center;
  
  .content__article {
    margin-left: 8rem;
    
    h1 {
      font-weight: 300;
    }
    
    ul {
      margin: 2rem 0 3rem 0;
      padding: 0;
      list-style: none;
      
      li + li {
        margin-top: .4rem;
      }
      
      li {
        display: flex;
        align-items: center;
        
        span.roxo {
          background: #E2CCFF;
          color: #6E21FF;
        }
        
        span.amarelo {
          background: #FEEECC;
          color: #FDB225;
        }
        
        span.verde {
          background: #D7F0E5;
          color: #3DB684;
        }
          
        span {
          margin-right: .5rem;
          border-radius: 50%;
          padding: .5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          
          i {
            font-size: 1.2rem;
          }
        }
      }
    }
    
    .button__price {
      margin-top: 2.5rem;
      background: none;
      border-left: none;
      border-top: none;
      border-right: none;
      border-bottom: 2px solid #6e00ff;
      padding: 0 1rem 1rem 1rem;
      cursor: pointer;
      font-weight: 400;
      font-family: 'Poppins', sans-serif;
      color: #6e00ff;
      display: block;
    }
  }
  
  @media (max-width: 768px) {
    img {
      display: none;
    }
    
    .content__article {
      margin-left: 0;
    }
  }
`;